/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/views/web/product/constants.ts
 * @Description: 商品详情定义常量
 */

export const PAGE_SIZE_OPT = ['10','20','30','40']
/**
* 评价状态，0=未评价，1=已评价
*/
enum EVALUTE_STATUS {
    WAITING = 0,
    DONE = 1,

}
/**
* 评价对象类型: 1=采购商 2=供应商 3=供应商商品 4=标品
*/
enum EVALUATE_OBJECT {
    PURCHASER = 1,
    SUPPLIER = 2 ,
    SUPPLIER_PRODUCT = 3,
    STANDARD_PRODUCT =4,
}


export { 
    EVALUTE_STATUS,
    EVALUATE_OBJECT,
 }


